import { combineReducers } from 'redux';

import types from './types';

const initialState = {
  isLoading: false,
  error: null,
  data: {},
};

function listRolesReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.LIST_ROLES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.LIST_ROLES_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.LIST_ROLES_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const getRoleInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function getRoleReducer(state = getRoleInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.GET_ROLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_ROLE_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.GET_ROLE_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const createRoleInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function createRoleReducer(state = createRoleInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.CREATE_ROLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.CREATE_ROLE_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.CREATE_ROLE_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const updateRoleInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function updateRoleReducer(state = updateRoleInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.UPDATE_ROLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_ROLE_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.UPDATE_ROLE_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

const removeRoleInitialState = {
  isLoading: false,
  error: null,
  data: {},
};

function removeRoleReducer(state = removeRoleInitialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.REMOVE_ROLE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.REMOVE_ROLE_FAILURE:
      return { ...state, isLoading: false, error: payload };
    case types.REMOVE_ROLE_SUCCESS:
      return { ...state, isLoading: false, data: { ...payload } };
    default:
      return state;
  }
}

export default combineReducers({
  listRoles: listRolesReducer,
  getRole: getRoleReducer,
  createRole: createRoleReducer,
  updateRole: updateRoleReducer,
  removeRole: removeRoleReducer,
});
